import React from 'react';
import { format } from 'date-fns';
import Button from '@/components/Button/Button';
import GridColumn from '@/components/Table/GridTable';
import { Passkey } from './Security.queries';

const formatDate = (date: unknown) =>
  date ? format(new Date(date as string), 'MMM d yyyy') : '—';

const passkeyColumns = (
  onDelete: (passkey: Passkey) => void,
  deleting: boolean
): GridColumn<Passkey>[] => [
  {
    id: 'device',
    header: 'Device',
    accessor: (row) => row.device ?? '—',
  },
  {
    id: 'added',
    header: 'Added',
    accessor: (row) => formatDate(row.createdAt),
    width: 110,
  },
  {
    id: 'lastUsed',
    header: 'Last used',
    accessor: (row) => formatDate(row.lastUsedAt),
    width: 110,
  },
  {
    id: 'actions',
    header: '',
    accessor: (row) => (
      <Button
        variant="danger"
        icon="trash"
        title="Delete passkey"
        aria-label="Delete passkey"
        disabled={deleting}
        onClick={() => onDelete(row)}
      />
    ),
    width: 60,
  },
];

export default passkeyColumns;
